import React from 'react'
import Delivery from '../home/Delivery'
import Product from '../home/Product'
import Products from './Products'
import Season from '../home/Season'
import Slider from '../home/Slider'
import Summer from '../home/Summer'
import Owl from '../home/Owl'

function Home() {
  return (
    <div>
      <Slider/>
      <Season/>
      <Product/>
      <Products title="men's clothing"/>
      <Products title="women's clothing"/>
      <Summer/>
      <Owl/>
      <Delivery/>
    </div>
  )
}

export default Home
